const PanelContent = {
  baseStyle: {
    ms: "auto",
    me: "auto",
    ps: {base: "8px", md: "15px"},
    pe: {base: "8px", md: "15px"},
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
